import React, { useEffect, useState } from 'react'

import { handleTabChange } from '@application/Interfaces/Features/StaticTradelane/utils'
import { useGetRoutes } from '@application/Interfaces/Hooks/useGetRoutes'
import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { Button } from '@application/Interfaces/Molecules/Button'
import { POPEYE_URL } from '@core/Constants/RouteConstants'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Tabs } from '@icontainers/design-system/dist/organisms/Tabs'
import { TradelanesType, TradelaneTab } from '@src/Application/Types/ComponentTypes'
import { Nullable } from '@src/Application/Types/Opt'
import { Route } from '@src/Infrastructure/Types/Routes'

import { RouteElement } from './RouteElement'
import { Error, Link, Loader, NoResult, RouteElementWrapper, TitleSection } from './Tradelanes.styled'
import { fetchData, getQueryParams } from './utils'

export const Tradelanes = ({
    buttonLink,
    buttonLabel,
    routesTitle,
    subtitle,
    mode,
    tabs,
}: TradelanesType): JSX.Element => {
    const { t } = useTranslation()

    const [selectedTab, setSelectedTab] = useState(tabs[0].title)
    const [routes, setRoutes] = useState<Nullable<Route[]>>()
    const [error, setError] = useState<boolean>(false)

    const tab = tabs.find((t) => t.title === selectedTab) as TradelaneTab

    const { refetch, isFetching } = useGetRoutes(getQueryParams(tab))

    useEffect(() => {
        fetchData({ refetch, setRoutes, setError })
    }, [selectedTab])

    return (
        <TitleSection title={routesTitle} subtitle={subtitle} mode={mode}>
            <Tabs
                id="routes"
                size="default"
                variant="scrollable"
                tabs={tabs.map((tab) => ({ id: tab.title, value: tab.title, label: t(tab.title) }))}
                onChangeCallback={handleTabChange(setSelectedTab)}
                className="tradeTab"
            />

            <Grid container mdUpSpacingTop={5} mdDownSpacingTop={3}>
                {!isFetching &&
                    routes?.map((route, index) => (
                        <RouteElementWrapper
                            item
                            xs={12}
                            md={6}
                            key={`${index}-route.country`}
                            mdUpSpacingRight={6}
                            spacingTop={2}
                            spacingBottom={2}
                        >
                            <RouteElement {...route} type="FCL" />
                        </RouteElementWrapper>
                    ))}
                {isFetching && <Loader cardCount={1} />}
                {!isFetching && routes?.length === 0 && (
                    <NoResult
                        message={t('noRatesMessage')}
                        link={POPEYE_URL}
                        linkLabel={t('findLatestRates')}
                        $mode={mode}
                    />
                )}
                {error && <Error message={t('requestError')} $mode={mode} />}
            </Grid>

            {!error && Boolean(routes?.length) && buttonLink && buttonLabel && (
                <Grid container justifyContent="center" spacingTop={10}>
                    <Link to={buttonLink}>
                        <Button mode={mode}>{buttonLabel}</Button>
                    </Link>
                </Grid>
            )}
        </TitleSection>
    )
}
